/**
 * Generation Brand Section
 *
 * Brand selection for image generation (Issue #203)
 * - Shows selected brand with preview (colors)
 * - Dropdown to change brand
 * - "Keine Marke" option
 *
 * WCAG 2.1 Level AA konform
 */

import { Tag } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BrandSelector } from '@/components/brands/BrandSelector';

interface GenerationBrandSectionProps {
  selectedBrandId: string | null;
  onBrandChange: (brandId: string | null) => void;
}

export function GenerationBrandSection({
  selectedBrandId,
  onBrandChange,
}: GenerationBrandSectionProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-sm font-medium text-neutral-700 dark:text-neutral-200">
        <Tag className="h-4 w-4" />
        Marke (optional)
      </div>

      <BrandSelector
        value={selectedBrandId}
        onChange={onBrandChange}
        label=""
        helpText={t('generation.brandHelp')}
      />
    </div>
  );
}
